import React from 'react';
import PropTypes from 'prop-types';
import computed from 'lib/mobx/computed';
import decorator from 'lib/lang/decorator';
import { when, observable } from 'mobx';
import { observer } from 'mobx-react';

import ScrollView from './scroll-view';

let scrollReveal;

if (process.env.ENV_WEB) {
    const ScrollReveal = require('scrollreveal');
    scrollReveal = ScrollReveal();
}

export class ScrollViewReveal {
    @observable scrollView: ?ScrollView;

    @computed get reveal() {
        if (!scrollReveal || !this.scrollView || !this.scrollView.container) {
            return undefined;
        }

        return (...args) => {
            const [target, configOrInterval, ...rest] = args;

            const config = {};

            if (this.scrollView.container !== window) {
                Object.assign(config, { container: this.scrollView.container });
            }

            const revealArgs = [target, config];

            if (configOrInterval !== undefined) {
                if (!isNaN(configOrInterval)) {
                    revealArgs.push(configOrInterval);
                } else if (configOrInterval instanceof Object) {
                    Object.assign(config, configOrInterval);
                }
            }

            return scrollReveal.reveal(...[...revealArgs, ...rest]);
        };
    }

    @computed get revealRef() {
        if (!scrollReveal || !this.scrollView || !this.reveal) {
            return undefined;
        }

        return (...args) => {
            const [ref, ...rest] = args;

            if (ref && window.getComputedStyle(ref).getPropertyValue('visibility') === 'hidden') {
                return this.reveal(ref, ...rest);
            }

            return this.reveal;
        };
    }
}

export default decorator(() => Component => {
    @observer
    class ScrollViewRevealable extends React.Component {
        static contextTypes = {
            scrollView: PropTypes.object,
        };

        scrollViewReveal: ScrollViewReveal;

        UNSAFE_componentWillMount() {
            this.scrollViewReveal = new ScrollViewReveal();
            this.scrollViewReveal.scrollView = this.context.scrollView;
        }

        componentWillUnmount() {
            if (this.disposer) {
                this.disposer();
            }
        }

        render() {
            return <Component scrollViewReveal={this.scrollViewReveal} {...this.props} />;
        }
    }

    return ScrollViewRevealable;
});
